/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType, getCustmerListById } from '@/api/common'
import { delNullProperty } from '@/utils/index'
import { menuBtn } from '@/utils/menu_level2_button'
import realTimeSokcet from '@/utils/socket.io'
import { Loading } from 'element-ui';
import commonData from "@/utils/commonData";
import CommonData from "@/utils/commonData";

@Component({})
export default class SchoolDetail extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        souCourseName: '',
        grade: '',
        caseStatus: '',
        souCourseType:'',
        specialized:''
    }
    page = 1
    limit = 20
    total = 0
    selfTotal = 0
    loading = false
    gradeList = CommonData.gradeList
    typeList= commonData.projectTypeArray
    menuBtn = menuBtn
    // computed
    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableData()
    }

    // updated(){
    //     this.$nextTick(() => {
    //         this.initSocket()
    //     })
    // }

    destroyed() {
        // this.socket.disconnect()
    }

    // methods
    // async getTableHeader() {
    //     this.loading = true
    //     const data: any = await gettHeaderByType(3)
    //     this.tableHeader = data.headerUserList
    //     this.loading = false
    //     this.getTableData()
    // }
    async getTableData() {
        this.loading = true
        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit, id: Number(this.$route.query.id) }
        const data: any = await getCustmerListById(delNullProperty(obj))
        this.tableData = data.customerList
        this.total = data.allNum
        this.loading = false
    }

    pageChange(page: number) {
        this.page = page
        this.getTableData()
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }
    initSocket() {
        const time = setInterval(() => {
            if(Vue.prototype.$socket.on) {
                realTimeSokcet(this.userId, 'MarketClue', this.getTableData)
                clearInterval(time)
            }
        }, 100)
    }

    @Watch('userId')
    handleWatchUserId() {
        this.initSocket()
    }
}
